/* Infinite You theme JS: cart drawer, product form, gallery, header */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => {
    const fmt = (window.theme && window.theme.moneyFormat) || '{{amount_no_decimals}} kr';
    const n = cents / 100;
    const s2 = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const s0 = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const comma = n.toFixed(2).replace('.', ',');
    return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, s0).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma).replace(/\{\{\s*amount[^}]*\}\}/, s2);
  };

  /* ---------- Cart drawer ---------- */
  const drawer = $('#cart-drawer');
  const body = $('[data-cart-body]');
  const foot = $('[data-cart-foot]');
  const lineTpl = $('#cart-line-template');
  const emptyTpl = $('#cart-empty-template');
  const FREE = (window.theme && window.theme.freeShipping ? window.theme.freeShipping : 700) * 100;

  function openDrawer() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open'); }
  function closeDrawer() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('drawer-open'); }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    const ship = $('[data-cart-shipping]');
    const left = Math.max(0, FREE - cart.total_price);
    const pct = Math.min(100, (cart.total_price / FREE) * 100);
    ship.innerHTML = (left > 0 ? `Handla för <b>${money(left)}</b> till för fri frakt` : `<span class="is-ok">Du har fri frakt</span>`) + `<div class="drawer__bar"><span style="width:${pct}%"></span></div>`;
    body.innerHTML = '';
    if (!cart.items.length) { body.appendChild(emptyTpl.content.cloneNode(true)); foot.hidden = true; return; }
    const ul = document.createElement('ul'); ul.className = 'drawer__lines';
    cart.items.forEach((item) => {
      const n = lineTpl.content.cloneNode(true);
      $$('[data-line-url]', n).forEach((a) => (a.href = item.url));
      const img = $('[data-line-img]', n); if (item.image) img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2'); else img.remove();
      $('[data-line-title]', n).textContent = item.product_title;
      $('[data-line-variant]', n).textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      $('[data-line-price]', n).textContent = money(item.final_line_price);
      const qty = $('[data-line-qty]', n); qty.value = item.quantity;
      $('[data-line-minus]', n).onclick = () => changeLine(item.key, item.quantity - 1);
      $('[data-line-plus]', n).onclick = () => changeLine(item.key, item.quantity + 1);
      qty.onchange = () => changeLine(item.key, parseInt(qty.value || '0', 10));
      $('[data-line-remove]', n).onclick = () => changeLine(item.key, 0);
      ul.appendChild(n);
    });
    body.appendChild(ul);
    foot.hidden = false;
    $('[data-cart-subtotal]').textContent = money(cart.items_subtotal_price);
    $('[data-cart-total]').textContent = money(cart.total_price);
    $('[data-cart-shipping-label]').textContent = left > 0 ? 'Beräknas i kassan' : 'Fri frakt';
  }
  const fetchCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const refreshCart = () => fetchCart().then(renderCart);
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) }).then((r) => r.json()).then(renderCart);
  }
  function addToCart(id, quantity = 1) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] }) })
      .then((r) => r.json()).then((res) => { if (res.status && res.status >= 400) throw new Error(res.description || res.message); return refreshCart(); }).then(openDrawer);
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
    const add = e.target.closest('[data-add-to-cart]');
    if (add) { e.preventDefault(); add.disabled = true; addToCart(add.dataset.addToCart).catch((err) => alert(err.message)).finally(() => (add.disabled = false)); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  if (drawer) refreshCart();

  /* ---------- Header ---------- */
  const menuBtn = $('[data-menu-toggle]'), mobile = $('[data-mobile-menu]');
  if (menuBtn) menuBtn.onclick = () => { const open = mobile.classList.toggle('is-open'); menuBtn.setAttribute('aria-expanded', open); };
  const searchBtn = $('[data-search-toggle]'), search = $('[data-search]');
  if (searchBtn) searchBtn.onclick = () => { const open = search.classList.toggle('is-open'); if (open) $('[data-search-input]').focus(); };

  /* ---------- Collection sort + filters ---------- */
  const sort = $('[data-sort]');
  if (sort) sort.onchange = () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u; };
  $$('[data-filter]').forEach((inp) => inp.addEventListener('change', () => {
    const u = new URL(location.href);
    ['filter.v.price.lte', 'filter.v.price.gte'].forEach((k) => u.searchParams.delete(k));
    $$('[data-filter]').forEach((i) => { if (i.type === 'checkbox') u.searchParams.delete(i.name); });
    $$('[data-filter]').forEach((i) => { if (i.checked) u.searchParams.append(i.name, i.value); });
    u.searchParams.delete('page'); location.href = u;
  }));

  /* ---------- Product page ---------- */
  const productEl = $('[data-product]');
  if (productEl) {
    const product = JSON.parse($('[data-product-json]').textContent);
    const form = $('[data-product-form]');
    const idInput = $('[data-variant-id]', form);
    const qty = $('[data-qty]', form);
    $('[data-qty-minus]', form).onclick = () => (qty.value = Math.max(1, parseInt(qty.value || '1', 10) - 1));
    $('[data-qty-plus]', form).onclick = () => (qty.value = parseInt(qty.value || '1', 10) + 1);

    const selected = $$('.option', form).map((o) => $('.option__btn.is-active', o)?.dataset.value);
    function currentVariant() {
      return product.variants.find((v) => v.options.every((val, i) => val === selected[i]));
    }
    function updateVariant() {
      const v = currentVariant();
      const submit = $('[data-submit]', form), txt = $('[data-submit-text]', form), stock = $('[data-stock]');
      if (!v) { submit.disabled = true; txt.textContent = 'Ej tillgänglig'; return; }
      idInput.value = v.id;
      submit.disabled = !v.available; txt.textContent = v.available ? 'Lägg i varukorg' : 'Slutsåld';
      if (stock) stock.textContent = v.available ? 'I lager – skickas inom 1–2 vardagar' : 'Tillfälligt slut';
      const cur = $('[data-price-current]'), cmp = $('[data-price-compare]');
      cur.textContent = money(v.price);
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      cmp.hidden = !onSale; cmp.textContent = onSale ? money(v.compare_at_price) : '';
      cur.classList.toggle('price__sale', !!onSale);
      const saving = $('[data-saving]'); if (saving) { saving.hidden = !onSale; if (onSale) $('[data-saving-pct]').textContent = Math.round((1 - v.price / v.compare_at_price) * 100); }
      if (v.featured_media) { const idx = product.media.findIndex((m) => m.id === v.featured_media.id); if (idx >= 0) showSlide(idx); }
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    }
    $$('.option', form).forEach((o, i) => $$('[data-option-btn]', o).forEach((btn) => btn.onclick = () => {
      $$('[data-option-btn]', o).forEach((b) => b.classList.remove('is-active')); btn.classList.add('is-active');
      selected[i] = btn.dataset.value; $('[data-option-value]', o).textContent = btn.dataset.value; updateVariant();
    }));
    form.addEventListener('submit', (e) => {
      e.preventDefault(); const submit = $('[data-submit]', form); submit.disabled = true;
      addToCart(idInput.value, parseInt(qty.value || '1', 10)).catch((err) => alert(err.message)).finally(() => (submit.disabled = false));
    });

    const slides = $$('[data-slide]', productEl), thumbs = $$('[data-thumb]', productEl);
    function showSlide(i) { slides.forEach((s, k) => (s.hidden = k !== i)); thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i)); }
    thumbs.forEach((t) => (t.onclick = () => showSlide(parseInt(t.dataset.thumb, 10))));
  }
})();
